// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3OVPN","list":"PatternAutocomplete_list__OFGEw"};